import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ControlesBTComponent } from './controles-bt/controles-bt.component';

const routes: Routes = [{ path: '', component: ControlesBTComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ControlesRoutingModule {}
